import { Component } from '@angular/core';

import { HelpCenterService } from './help-center-article.service';
import { NbToastrService, NbGlobalPhysicalPosition, NbDialogService } from '@nebular/theme';
import { ConfirmOperationComponent } from '../../../@theme/components/confirm-operation/confirm-operation.component';
import { Router } from '@angular/router';
import { ignoreElements } from 'rxjs/operators';

@Component({
  selector: 'ngx-help-center-article',
  templateUrl: './help-center-article.component.html',
  styleUrls: ['./help-center-article.component.scss'],
})
export class HelpCenterArticleComponent {

  public articles = [];

  settings = {
    actions: {
      columnTitle: 'Ações',
    },
    add: {
      addButtonContent: '<i class="nb-plus"></i>',
      createButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash"></i>',
    },
    mode: 'external',
    columns: {
      title: {
        title: 'Título',
        type: 'string',
      },
      category: {
        title: 'Categoria',
        type: 'string',
      },
      status: {
        title: 'Status',
        type: 'html',
        valuePrepareFunction: (status) => {
          if (status === 'Publicado') {
            return '<i class="fas fa-circle text-success"></i> ' + status;
          } else {
            return '<i class="fas fa-circle text-warning"></i> ' + status;
          }
        },
      },
      custom: {
        title: 'Performance',
        type: 'html',
        filter: false,
        valuePrepareFunction: (colunmValue, rowValue) => {
          const amountView = rowValue.amountView;
          const sadReaction = rowValue.sadReaction;
          const neutralReaction = rowValue.neutralReaction;
          const happyReaction = rowValue.happyReaction;



          const imgRuim = '<img src="assets/images/SVG/ruim.svg" width="15" alt="Ruim" title="Ruim"> ' + sadReaction + ' </img>';
          const imgBom = '<img src="assets/images/SVG/bom.svg" width="15" alt="Bom" title="Bom"> ' + neutralReaction + ' </img>';
          const imgExelente = '<img src="assets/images/SVG/excelente.svg" width="15" alt="Excelente"' +
            ' title="Excelente"> ' + happyReaction + ' </img>';

          const vis = '<img src="assets/images/SVG/visualizar.svg" width="15" alt="Visualização" title="Visualização"> '
            + amountView + ' </img>';

          const html = vis + imgRuim + imgBom + imgExelente;
          return html;
        },
      },
    },
    noDataMessage: 'Nenhum registro encontrado',
  };

  constructor(private helpCenterService: HelpCenterService, private toastrService: NbToastrService,
    private router: Router, private dialogService: NbDialogService) {
    this.getAll();
  }

  getAll() {
    this.helpCenterService.query().toPromise().then(response => {
      this.articles = response.body;
    });
  }
  openCreateDialog() {
    this.router.navigate(['pages/admin/help-center-article', 'create']);
  }

  openEditDialog(event): void {
    this.router.navigate(['pages/admin/help-center-article', event.data.id]);
  }

  onDeleteConfirm(event): void {
    this.dialogService.open(ConfirmOperationComponent, {
      closeOnBackdropClick: false,
      context: {
        title: 'Excluir Artigo',
        text: `Você realmente deseja excluir o Artigo (${event.data.title}) ?`,
        accent: 'danger',
        force: false,
      },
    }).onClose.subscribe(response => response.confirmed && this.delete(event.data.id));
  }

  delete(id) {
    this.helpCenterService.remove(id).toPromise().then(response => {
      this.toastrService.show('Artigo', 'excluído com sucesso',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'success' });
      this.getAll();
    }).catch(err => {
      this.toastrService.show('Artigo', err.error.title,
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }
}
